// @flow

//
// React
//
import React from 'react';

//
// Material UI
//
import { makeStyles } from '@mui/styles';

//
// Trix Data
//
import {
    type Error,
    hasErrorCausesForLocation,
    formatErrorsForLocation,
} from '../../../../trix-web-data-commons';

//
// Data Source
//
import { loadData } from '../../../extender/dataSource';

//
// Components
//
import {
    AddressFormPaneField,
} from '../../../../trix-web-components-domain-geo';

//
// Props
//
type Props = {
    //
    // Hal Forms Template
    //
    __halFormsTemplate: any,
    container: any,

    data: any,
    
    name: string,
    label: string,

    value: any,
    error: any,

    onChange: (value: string, meta: any) => void,

    //
    // Meta data. Meta data is passed back along with changed value 
    // to the change handler
    //
    dataPath: string,
}; // End of Props

//
// Component
//
const HalFormsAddressFormPaneField = (props: Props): any => {
    // Hooks
    // const classes = useStyles();
    // End Hooks

    let onLoadCountries: any = undefined;
    if (props.__halFormsTemplate.countriesDataSource) {
        onLoadCountries = (value: string, reject: (error: any) => void, resolve: (data: any) => void) => {
            const env: any = {
                dataSource: props.__halFormsTemplate.countriesDataSource,
                data: props.data,
                container: props.container,
            };

            const params = {
                text: value,
                data: props.data
            };

            loadData (env) (params, reject, (data: any) => {
                const embedded = (data && data.body && data.body._embedded) ?
                    data.body._embedded : {};
                const values = Object.values(embedded);
                const items = (values && values.length > 0) ? (values[0]) : [];
                // $FlowFixMe
                resolve(items);
            });
        }
    }

    let onLoadCities: any = undefined;
    if (props.__halFormsTemplate.citiesDataSource) {
        onLoadCities = (value: string, reject: (error: any) => void, resolve: (data: any) => void) => {
            const env: any = {
                dataSource: props.__halFormsTemplate.citiesDataSource,
                data: props.data,
                container: props.container,
            };

            const params = {
                text: value,
                data: props.data
            };

            loadData (env) (params, reject, (data: any) => {
                const embedded = (data && data.body && data.body._embedded) ?
                    data.body._embedded : {};
                const values = Object.values(embedded);
                const items = (values && values.length > 0) ? (values[0]) : [];
                // $FlowFixMe
                resolve(items);
            });
        }
    }

    let onLoadNeighbourhoods: any = undefined;
    if (props.__halFormsTemplate.neighbourhoodsDataSource) {
        onLoadNeighbourhoods = (value: string, reject: (error: any) => void, resolve: (data: any) => void) => {
            const env: any = {
                dataSource: props.__halFormsTemplate.neighbourhoodsDataSource,
                data: props.data,
                container: props.container,
            };

            const params = {
                text: value,
                data: props.data
            };

            loadData (env) (params, reject, (data: any) => {
                const embedded = (data && data.body && data.body._embedded) ?
                    data.body._embedded : {};
                const values = Object.values(embedded);
                const items = (values && values.length > 0) ? (values[0]) : [];
                // $FlowFixMe
                resolve(items);
            });
        }
    }

    let onLoadStreets: any = null;
    if (props.__halFormsTemplate.streetsDataSource) {
        onLoadStreets = (value: string, reject: (error: any) => void, resolve: (data: any) => void) => {
            const env: any = {
                dataSource: props.__halFormsTemplate.streetsDataSource,
                data: props.data,
                container: props.container,
            };

            const params = {
                text: value,
                data: props.data
            };

            loadData (env) (params, reject, (data: any) => {
                const embedded = (data && data.body && data.body._embedded) ?
                    data.body._embedded : {};
                const values = Object.values(embedded);
                const items = (values && values.length > 0) ? (values[0]) : [];
                // $FlowFixMe
                resolve(items);
            });
        }
    }

    return (
        <AddressFormPaneField
            name={props.name}
            label={props.label}
            error={props.error}
            data={props.value}

            onChange={props.onChange}

            // loaders callbacks 
            onLoadCountries={onLoadCountries}
            onLoadCities={onLoadCities}
            onLoadNeighbourhoods={onLoadNeighbourhoods}
            onLoadStreets={onLoadStreets}

            dataPath={props.dataPath}
        />
    );
};
export default HalFormsAddressFormPaneField;
